import { observer } from 'mobx-react'
import { Card, CardBody, CardHeader } from 'reactstrap'
import React from 'react'
import { observable, toJS } from 'mobx'
import Util from '../../common/Util'
import ApiClient, { ApiRoutes } from '../../api/ApiClient'
import { route } from '../../routes/routes'
import LoadingPanel from '../LoadingPanel'
import _ from 'lodash'

type ApplicationsData = {
  applicationsCount: {
    day: number
    month: number
    year: number
    open: number
    old: number
  }
}

type Props = {
  filters: {
    state?: string
    areaId?: number
    chapterId?: number
  }
  onShowApplicationList: (url: string, title: string) => void
}

@observer
export default class ApplicationsDashboard extends React.Component<Props> {
  @observable
  private applications?: ApplicationsData
  @observable
  private error?: string
  @observable
  private loading = false

  componentDidMount () {
    this.loadData().then()
  }

  componentDidUpdate (prevProps: Readonly<Props>, prevState: Readonly<{}>, snapshot?: any) {
    if (!_.isEqual(toJS(prevProps.filters), toJS(this.props.filters))) {
      this.loadData().then()
    }
  }

  private loadData = async () => {
    try {
      this.error = undefined
      this.loading = true

      const response = await ApiClient.getInstance().get(route(ApiRoutes.dashboard.applications, {}, this.props.filters))

      this.applications = response.data

      this.loading = false
    } catch (err) {
      this.error = Util.extractErrorMessage(err.response)
    }
  }

  render () {
    return <Card>
      <CardHeader>
        <b>Applications In Wired</b>
      </CardHeader>
      <CardBody>
        <LoadingPanel loading={this.loading} loaded={!!this.applications} error={this.error}>
          {
            this.applications
              ? <>
                <div className="d-flex">
                  <div className="flex-fill">
                    Today
                  </div>
                  <div className="text-right">
                    <a href="" onClick={ev => {
                      ev.preventDefault()
                      this.props.onShowApplicationList(route(ApiRoutes.dashboard.applications, {}, {
                        ...this.props.filters,
                        list: 'day',
                      }), 'Applications Today')
                    }}>
                    {Util.formatNumber(this.applications!.applicationsCount.day)}
                    </a>
                  </div>
                </div>
                <div className="d-flex">
                  <div className="flex-fill">
                    This Month
                  </div>
                  <div className="text-right">
                    <a href="" onClick={ev => {
                      ev.preventDefault()
                      this.props.onShowApplicationList(route(ApiRoutes.dashboard.applications, {}, {
                        ...this.props.filters,
                        list: 'month',
                      }), 'Applications This Month')
                    }}>
                    {Util.formatNumber(this.applications!.applicationsCount.month)}
                    </a>
                  </div>
                </div>
                <div className="d-flex">
                  <div className="flex-fill">
                    This Year
                  </div>
                  <div className="text-right">
                    <a href="" onClick={ev => {
                      ev.preventDefault()
                      this.props.onShowApplicationList(route(ApiRoutes.dashboard.applications, {}, {
                        ...this.props.filters,
                        list: 'year',
                      }), 'Applications This Year')
                    }}>
                    {Util.formatNumber(this.applications!.applicationsCount.year)}
                    </a>
                  </div>
                </div>
                <div className="d-flex mt-4">
                  <div className="flex-fill">
                    Open
                  </div>
                  <div className="text-right">
                    <a href="" onClick={ev => {
                      ev.preventDefault()
                      this.props.onShowApplicationList(route(ApiRoutes.dashboard.applications, {}, {
                        ...this.props.filters,
                        list: 'open',
                      }), 'Open Applications')
                    }}>
                    {Util.formatNumber(this.applications!.applicationsCount.open)}
                    </a>
                  </div>
                </div>
                <div className="d-flex">
                  <div className="flex-fill">
                    Open but old (more than 60 days)
                  </div>
                  <div className="text-right">
                    <a href="" onClick={ev => {
                      ev.preventDefault()
                      this.props.onShowApplicationList(route(ApiRoutes.dashboard.applications, {}, {
                        ...this.props.filters,
                        list: 'old',
                      }), 'Old Applications')
                    }}>
                    {Util.formatNumber(this.applications!.applicationsCount.old)}
                    </a>
                  </div>
                </div>
              </>
              : null
          }
        </LoadingPanel>
      </CardBody>
    </Card>
  }
}
